"use strict";
import {on, findIn, findAllIn,} from '@elements/dom-utils';
import {onFind} from "@elements/init-modules-in-scope";
import Collapse from 'bootstrap/js/dist/collapse';

export function init() {

    onFind('.js-multi-collapse', container => {

        let allOpen = findIn('.js-multi-collapse__all', container);
        let allClose = findIn('.js-multi-collapse__close-all', container);

        findAllIn('.collapse', container).map(item => {
            on('click', (e) => {
                let collapseInstance = Collapse.getOrCreateInstance(item, {toggle: true});
                collapseInstance.show();
            }, allOpen);

            on('click', (e) => {
                let collapseInstance = Collapse.getOrCreateInstance(item, {toggle: true});
                collapseInstance.hide();
            }, allClose);
        });
    });
}